import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import {isUndefined} from 'lodash'
import IntlMessages from 'util/IntlMessages';

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0),
            //   width: '28ch',
        },
    },
}));

function AktivitetsTyp(props) {
    const classes = useStyles();
    const [Type, settype] = React.useState(0);
    const handleChange = (event) => {
        settype(event.target.value);
        props.handleChange("Rapport",event.target.value)
    };
    const currencies = [
        {value: 0,disabled:true,label: <IntlMessages id="Choose"/>,Display:true},
        {value: 'Avtal',disabled:false,label: <IntlMessages id="File.type.Contract"/>,Display:true},
        {value: 'Prospekt',disabled:false,label:<IntlMessages id="Prospectus" />,Display:true},
        {value: 'Order',disabled:parseInt(props.userLicans) ===1 ?true:false ,label:<IntlMessages id="Order" />,Display:parseInt(props.userLicans) ===1 ?false:true },
        //{value: 'Order kunddata',disabled:parseInt(props.userLicans) ===1 ?true:false,label:<IntlMessages id="Label.Order.CustomerData" />,Display:parseInt(props.userLicans) ===1 ?false:true},
        //{value: 'Order med artiklar',disabled:parseInt(props.userLicans) ===1 ?true:false,label:<IntlMessages id="Label.Order.Items" />,Display:parseInt(props.userLicans) ===1 ?false:true},
        //{value: 'Order provision',disabled:parseInt(props.Flags.Role) === 11?parseInt(props.userLicans) ===1 ?true:false:true,label:<IntlMessages id="Label.Order.commission" />,Display:parseInt(props.Flags.Role) === 11?parseInt(props.userLicans) ===1 ?false:true:false},
        {value: 'Kunder',disabled:false,label:<IntlMessages id="Customers"/>,Display:true},
        {value: 'Kunder med artiklar',disabled:false,label:<IntlMessages id="Label.Customers.items" />,Display:true},
        //{value: 'Kunder händelser',disabled:false,label:<IntlMessages id="Label.Customers.events" />,Display:true},
        {value: 'Kontaktpersoner',disabled:false,label:<IntlMessages id="ContactPersons"/>,Display:true},
        {value: 'Moten',disabled:false,label:<IntlMessages id="Dialer.Events" />,Display:true},
        //{value: 'Ärende',disabled:false,label:<IntlMessages id="Errand" />,Display:true},
        //{value: 'Tillgodo',disabled:false,label:<IntlMessages id="Label.Credit" />,Display:true},
        {value: 'Projekt',disabled:false,label:<IntlMessages id="Project" />,Display:true},
        //{value: 'Projekt Tidsrapport',disabled:false,label:<IntlMessages id="Label.project.Time.report" />,Display:true},
        {value: 'Aktiviteter',disabled:false,label:<IntlMessages id="Activities" />,Display:true},
        //{value: 'Order artiklar',disabled:parseInt(props.userLicans) ===1 ?true:false,label:<IntlMessages id="Chips.Order.Items" />,Display:parseInt(props.userLicans) ===1 ?false:true},
        //{value: 'Avtalsfakturering',disabled:parseInt(props.Flags.Fortnox) === 1?false:true,label: 'Avtalsfakturering',Display:true},
        //{value: 'Fakturor',disabled:parseInt(props.Flags.Fortnox) === 1?false:true,label:<IntlMessages id="Invoices" />,Display:true},
        {value: 'E-signering',disabled:false,label:<IntlMessages id="E-signing" />,Display:true},
        //{value: 'Artikeltaggar',disabled:false,label:<IntlMessages id="Label.Items.Tags" />,Display:true},
        {value: 'Offert',disabled:false,label: <IntlMessages id="File.type.Offer"/>,Display:true},
        
    ];
    
    return (
                <TextField
                    label={<IntlMessages id="Report"/>}
                    select
                    variant="outlined"
                    size="small"
                    value={Type}
                    width={150}
                    onChange={handleChange}
                    SelectProps={{
                        native: true,
                    }}
                >
                    {currencies.filter(item=>item.Display === true).map((option,index) => (
                        <option  key={index} disabled={option.disabled} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </TextField>
    );
}
export default AktivitetsTyp;